class HeaderNav {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // スマホナビ開閉
    const navToggle = '.js-header-nav-toggle';
    const spNav = '.js-sp-nav';
    $(navToggle).on('click',function(){
      $('body').toggleClass("no_scroll")
      $(spNav).slideToggle();
      $(this).toggleClass('is-active');
    })
  }
}
